module.exports = __webpack_public_path__ + "img/stamp_drag_on.b72e5dcb.svg";